/**
 * Whether the current user may open the given path: every matched route's
 * `meta.accessHandler` (if any) must allow it.
 */
export function canAccessPath(router, path) {
  const match = router.resolve(path);
  if (!match) {
    return false;
  }

  return match.matched.every(m => !m.meta || !m.meta.accessHandler || m.meta.accessHandler());
}
